import { getPrefixedRoute } from 'services/theming';

/**
 * These paths are used to hide specific header links on desktop
 * in order to provide a more focused view on their respective screen components.
 */
export const focusHeaderPaths = {
  checkout: () => '/inputs/checkout',
  quote: () => '/inputs/quote',
};
